import FsLightbox from "fslightbox-react";
import { useState } from "react";
import KYouthProgramme2 from "./KYouthProgramme2";
import KYouthProgramme3 from "./KYouthProgramme3";

const KYouthProgramme1 = () => {
  const [toggler, setToggler] = useState(false);
  const videoLink = ["https://www.youtube.com/watch?v=pNje3bWz7V8"];
  return (
    <>
      <div
        id="k-youth-programme-2026"
        className="edu-workshop-area eduvibe-home-three-video workshop-style-1 edu-section-gap bg-image-area"
        style={{
          backgroundColor: "var(--color-contrast-dark)",
          scrollMarginBlockStart: 100,
        }}
        // style={{ backgroundImage: "url(../../images/bg/breadcrumb-bg.jpg)" }}
      >
        <div className="container eduvibe-animated-shape">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "5rem" }}
          >
            <KYouthProgramme3 />
            <KYouthProgramme2 />
          </div>

          <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
            <div className="shape-image shape-image-1">
              <img
                src="/k-youth/images/shapes/shape-09-01.png"
                alt="Shape Thumb"
              />
            </div>
            <div className="shape-image shape-image-2">
              <img
                src="/k-youth/images/shapes/shape-04-05.png"
                alt="Shape Thumb"
              />
            </div>
            <div className="shape-image shape-image-3">
              <img
                src="/k-youth/images/shapes/shape-13-02.png"
                alt="Shape Thumb"
              />
            </div>
          </div>
        </div>
      </div>
      <FsLightbox
        toggler={toggler}
        sources={videoLink}
        maxYoutubeVideoDimensions={{ width: 900, height: 550 }}
      />
    </>
  );
};

export default KYouthProgramme1;
